var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconIncPayroll(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 5.75H7.25C6.85218 5.75 6.47064 5.90804 6.18934 6.18934C5.90804 6.47064 5.75 6.85218 5.75 7.25C5.75 7.64782 5.90804 8.02936 6.18934 8.31066C6.47064 8.59196 6.85218 8.75 7.25 8.75H8.25C8.64782 8.75 9.02936 8.90804 9.31066 9.18934C9.59196 9.47064 9.75 9.85218 9.75 10.25C9.75 10.6478 9.59196 11.0294 9.31066 11.3107C9.02936 11.592 8.64782 11.75 8.25 11.75H5.75M7.75 11.75V13.25M7.75 4.25V5.75M0.75 18.75V2.75C0.75 2.21957 0.960714 1.71086 1.33579 1.33579C1.71086 0.960714 2.21957 0.75 2.75 0.75H12.75C13.2804 0.75 13.7891 0.960714 14.1642 1.33579C14.5393 1.71086 14.75 2.21957 14.75 2.75V18.75L11.75 16.75L9.75 18.75L7.75 16.75L5.75 18.75L3.75 16.75L0.75 18.75Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIncPayroll);
export default __webpack_public_path__ + "static/media/icon_inc_payroll.058ef02579d4b71bd9a2cc1337ed315c.svg";
export { ForwardRef as ReactComponent };